import { Contact } from '@contacts/interfaces/contact';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

@Component({
  name: 'bpc-booking-event-select-info',
  components: {},
})
export default class BookingEventSelectInfo extends Vue {
  @Prop(Object) readonly element: Record<string, any>;

  public onClick($event) {
    this.$emit('click', this.element);
  }

  formatDate(date): string {
    if (date) {
      return moment(String(date)).format('DD/MM/YYYY');
    }
    return '';
  }

  formatTime(time): string {
    if (time) {
      return time.substr(0, 5);
    }
    return '';
  }
}
